<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card grid-list-md>
      <ModelTitle title="Edit Fee" @close="close()" />
      <v-card-text v-if="Student">
        <v-row>
          <v-col cols="12" sm="12">
            <div>
              Student:
              <span class="font-weight-bold text-capitalize">{{
                Student.Student.fullName
                }}</span>
            </div>
            <div>{{ Student.Class.name }}</div>
            <div><v-checkbox class="mt-0" label="Count In Subscription" hide-details outlined dense
              v-model="countInSubscription"></v-checkbox></div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="Student">
        <v-row align="center">
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()" class="right-input"
              v-model="fee" label="Fee"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()" class="right-input"
              v-model="discount" label="Discount"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()" class="right-input"
              v-model="charity" label="Charity"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" offset-md="6">
            <v-text-field outlined dense hide-details type="number" @focus="$event.target.select()" class="right-input"
              v-model="parentPay" readonly label="Parent Pay"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text v-if="Student">
        <div>
          {{ Student.Student.fullName }} fee will be {{ balancePayment | currency }} a
          month. And {{ charity | currency }} will be collected by sponsor / donation.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" text @click="close()">Close</v-btn>
        <v-btn color="accent" :loading="loading" dark @click="submit()">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import classesService from "@/modules/Classes/service.js";

export default {
  props: {
    editDialog: {
      default: false,
    },
    editStudent: {
      type: Object,
    },
  },
  name: "update-Student",
  data() {
    return {
      countInSubscription: true,
      loading: false,
      dialog: false,
      Student: null,
      charity: 0,
      fee: 0,
      discount: 0,
      sponsor: 0,
      parentPay: 0,
    };
  },
  computed: {
    ...mapGetters("global", ["currentUser"]),
    balancePayment() {
      return this.fee - this.discount - this.charity;
    },
  },
  watch: {
    editDialog(val) {
      this.Student = this.editStudent;
      console.log("this.Student", this.Student);
      this.dialog = val;
      this.countInSubscription = this.Student.countInSubscription;
      this.fee = this.Student.fee;
      this.discount = this.Student.discount;
      this.sponsor = this.Student.sponsor;
      this.parentPay = this.Student.parentPay;
      this.charity = this.Student.charity;

      // this.getClasses();
      // this.getTeacher();
    },
    selectedClass(val) {
      console.log("val in selected ", val);
      this.fee = val.defaultFee;
      this.parentPay = val.defaultFee;
    },
    discount(val) {
      this.parentPay = this.fee - val - this.charity;
    },
    fee(val) {
      this.parentPay = val - this.discount - this.charity;
    },
    charity(val) {
      this.parentPay = this.fee - this.discount - val
    },
    parentPay(val) {
      this.sponsor = this.fee - this.discount - val;
    },
  },
  methods: {
    close() {
      this.empty();
      this.$emit("close");
    },
    empty() {
      this.Student = null;
      this.countInSubscription = true;
      this.fee = 0;
      this.discount = 0;
      this.sponsor = 0;
      this.parentPay = 0;
      this.charity = 0;

    },
    submit() {
      this.loading = true;
      const obj = {
        countInSubscription: this.countInSubscription,
        fee: this.fee,
        discount: this.discount,
        sponsor: this.sponsor,
        parentPay: this.parentPay,
        charity: this.charity,
      }
      return classesService
        .updateClassStudent(this.Student.id, obj)
        .then((result) => {
          if (result.status) {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                icon: "success",
                title: "Student is updated",
              });
            this.loading = false;
            this.$emit("submit");
            this.close();
          }
        })
        .catch((err) => {
          console.log('err', err)
          this.loading = false;
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              icon: "error",
              title: err.data.message,
            });
        });
    },
  },
};
</script>

<style scoped></style>
